var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"targetEl",staticClass:"il-lazy",style:(("min-height: " + (_vm.minHeight ? (_vm.minHeight + 'px') : undefined)))},[(_vm.shouldRender)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }